module.exports = __webpack_public_path__ + "static/img/10.49a803aa.png";